import { createAsyncThunk } from '@reduxjs/toolkit';
import { permissionsAPI } from './permissionsAPI';

export const getPermissionForRole = createAsyncThunk('service/authority', async (role) => {
  try {
    const response = await permissionsAPI.getPermissionsForRole(role);
    return response.data;
  } catch (error) {
    console.error(error);
  }
});
